<router-outlet id="topOutlet" name="topOutlet"></router-outlet>
<!-- CONTENT -->
<div class="relative flex flex-col items-center">
  <div class="container w-screen flex flex-1 h-full gap-x-6 mt-5 md:mt-[40px]">
    <div class="flex flex-col flex-1 relative lg:max-w-[calc(100%-var(--infobar-width))]">
      <router-outlet  id="standContent" #outlet="outlet"></router-outlet>
      <div class="w-full relative mt-12" [style.backgroundColor]="'rgba(var(--' + currentHallCssClass() + ', 0.8))'">
        <div class="container py-1 text-2xl text-white">
          <span i18n>You may be interested in:</span><i id="stand-free-products-category" class="ml-1">{{this.standService.currentCategory().shortName}}</i>
        </div>
      </div>
      <div id="productScroller" class="container mt-7">
        @if(isCanonicalPage()) {
          <paged-virtual-scroller id="stand-free-random-products"
            [scrollWithMainScrollbar]="true"
            [itemTpl]="productScrollerTpl"
            [scaleUpOnRender]="scaleUpOnRender"
            [itemHeight]="290"
            [itemWidth]="315"
            [pageSize]="8"
            [itemsQuery]="productsQuery"/>
        } @else {
          @defer() {
            <paged-virtual-scroller
            [scrollWithMainScrollbar]="true"
            [itemTpl]="productScrollerTpl"
            [scaleUpOnRender]="scaleUpOnRender"
            [itemHeight]="290"
            [itemWidth]="315"
            [pageSize]="8"
            [itemsQuery]="productsQuery"/>
          }
        }

        <ng-template let-item #productScrollerTpl>
          <product-block #productBlock
            class="w-[290px] h-[275px]"
            [productItem]="item"
            [urlPrefix]="(item?.company | getCompanyUrl) + '/products/'"
            [imageSizes]="[{w: 288, h: 162, resizeMode: 'fill'}]"
            itemListId="standfree_related_products-list"
            [itemListName]="company().slug + '_related_products-list'"/>
        </ng-template>
      </div>
    </div>
    <div class="hidden w-[335px] lg:flex flex-col items-center">
      @if (showOverlay) {
        <info-bar class="company-info hidden lg:block" *renderIf="{mediaSelector:'gt-md'}"></info-bar>
      }
      @else{
        <info-bar class="company-info hidden lg:block z-40" *renderIf="{mediaSelector:'gt-md'}"></info-bar>
      }
      <div *renderIf="{mediaSelector:'gt-lg'}" class="hidden lg:block sticky top-[500px] mt-8 w-[325px] h-[940px]">
        @defer () {
          <paged-virtual-scroller
          class="flex h-full"
          [itemTpl]="newsScrollerTpl"
          [itemWidth]="335"
          [itemHeight]="312"
          [pageSize]="4"
          [itemsQuery]="newsQuery"
          [wrapInScrollbar]="true"/>
        }

      </div>

      <ng-template let-item let-index="index" #newsScrollerTpl>
        <news-block
          class="w-[325px] h-[300px] mb-3"
          [newsItem]="item"
          [absoluteUrl]="true"
          [itemIndex]="index"
          [imageSizes]="[
          {w: 323, h: 224, resizeMode: 'fill'}
          ]"/>
      </ng-template>
    </div>

  </div>
  <!-- ALTERNATIVE PRODUCTS -->


</div>
